import { useEffect } from "react";

const SITE = "https://tallerdesuspensioneslagringamerida.com";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export default function useSeo(title, description, fullTitle = false) {
  useEffect(() => {
    const t = fullTitle ? title : `${title} | Taller de Suspensiones La Gringa`;
    const url = SITE + (window.location.pathname === "/" ? "/" : window.location.pathname.replace(/\/$/, ""));
    document.title = t;
    setMeta("name", "robots", "index, follow");
    setMeta("property", "og:title", t);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", t);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setCanonical(url);
    window.scrollTo(0, 0);
  }, [title, description, fullTitle]);
}

export const useNoIndex = () => {
  useEffect(() => {
    document.title = "Panel | Taller de Suspensiones La Gringa";
    setMeta("name", "robots", "noindex, nofollow");
  }, []);
};
